<div class="history-dialog">

  <div class="history-header">
    <mat-icon class="header-icon">history</mat-icon>
    <h2>Historique de la demande <span class="demand-num">{{ demandNumber }}</span></h2>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="history-body">

    <div class="loading" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div class="empty" *ngIf="!isLoading && items.length === 0">
      <mat-icon>inbox</mat-icon>
      <p>Aucun historique pour cette demande.</p>
    </div>

    <div class="timeline" *ngIf="!isLoading && items.length > 0">
      <div class="timeline-item" *ngFor="let item of items">

       <div class="timeline-dot"
     [style.border-color]="operationIconColor(item.log.operation)">
  <mat-icon [style.color]="operationIconColor(item.log.operation)">
    {{ operationIcon(item.log.operation) }}
  </mat-icon>
</div>

        <div class="timeline-card">

          <div class="card-top">
            <span class="op-badge" [style.background-color]="operationColor(item.log.operation)">
              {{ operationLabel(item.log.operation) }}
            </span>
            <span class="projet" *ngIf="item.projet">
              <mat-icon>folder</mat-icon>{{ item.projet }}
            </span>
            <span class="date">{{ item.date | date: "dd/MM/yyyy 'à' HH:mm" }}</span>
          </div>

          <!-- Changement de statut -->
          <div class="status-change" *ngIf="isStatusChange(item)">
            <span class="section-label">Statut</span>
            <span class="statut-chip" [style.border-color]="statutColor(item.statutAvant)"
                  [style.color]="statutColor(item.statutAvant)">
              {{ item.statutAvant || '—' }}
            </span>
            <mat-icon class="arrow">arrow_forward</mat-icon>
            <span class="statut-chip filled" [style.background-color]="statutColor(item.statutApres)">
              {{ item.statutApres }}
            </span>
          </div>

          <!-- Motif -->
          <div class="motif" *ngIf="item.motif">
            <mat-icon>comment</mat-icon>
            <span><b>Motif :</b> {{ item.motif }}</span>
          </div>

          <!-- Champs modifiés -->
          <div class="changes" *ngIf="item.changes.length > 0">
            <div class="changes-title">
              <mat-icon>swap_horiz</mat-icon> Champs modifiés
            </div>
            <table class="changes-table">
              <tr *ngFor="let c of item.changes">
                <td class="field-name">{{ enrichEcheanceLabel(c, item.log) }}</td>
                <td class="before">{{ c.before ?? '—' }}</td>
                <td class="sep"><mat-icon>east</mat-icon></td>
                <td class="after">{{ c.after ?? '—' }}</td>
              </tr>
            </table>
          </div>

          <div class="card-footer">
            <div class="actor">
              <mat-icon>person</mat-icon>
              <span>{{ item.log.actorDisplayName || item.log.actorIdentifier || 'Inconnu' }}</span>
              <span class="role" *ngIf="item.log.actorRole">{{ item.log.actorRole }}</span>
            </div>
            <span class="identifier" *ngIf="item.log.actorIdentifier">{{ item.log.actorIdentifier }}</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>